import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description?: string;
  image?: string;
  url?: string;
}

export const usePageSEO = ({ title, description, image, url }: SEOProps) => {
  useEffect(() => {
    // 1. Update Title
    document.title = title;

    // Helper to update or create meta tags
    const updateMeta = (selector: string, content: string | undefined, createAttrs: Record<string, string>) => {
      if (!content) return;
      
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        Object.entries(createAttrs).forEach(([key, value]) => element!.setAttribute(key, value));
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // 2. Standard Description
    updateMeta('meta[name="description"]', description, { name: 'description' });

    // 3. Open Graph (Facebook, WhatsApp, Slack, etc.)
    updateMeta('meta[property="og:title"]', title, { property: 'og:title' });
    updateMeta('meta[property="og:description"]', description, { property: 'og:description' });
    updateMeta('meta[property="og:image"]', image, { property: 'og:image' });
    updateMeta('meta[property="og:url"]', url || window.location.href, { property: 'og:url' });
    updateMeta('meta[property="og:type"]', 'website', { property: 'og:type' });

    // 4. Twitter Cards
    updateMeta('meta[name="twitter:card"]', image ? 'summary_large_image' : 'summary', { name: 'twitter:card' });
    updateMeta('meta[name="twitter:title"]', title, { name: 'twitter:title' });
    updateMeta('meta[name="twitter:description"]', description, { name: 'twitter:description' });
    updateMeta('meta[name="twitter:image"]', image, { name: 'twitter:image' });

  }, [title, description, image, url]);
};
